export default "__VITE_ASSET__qV5JW2_k__"